import axios from "@/axios/tokenInterceptor";
import { defineStore } from "pinia";
import { useAPIStore, useUtilsStore } from "@/store";
import router from "@/router";
import _ from "lodash";
import dayjs from "dayjs";
// "維修管理" 狀態管理
export const useRepairStore = defineStore("Repair", {
  // data
  state: () => ({
    // edit or view
    PageType: "",
    // 下拉選單
    DropdownArray: {
      Area: [],
      Layer: [],
      Staff: [],
    },
    // 表單
    Form: {
      ApplicationDate: "",
      Applicant: "",
      ApplicantNickName: "",
      RepairId: "",
      AssetsId: "",
      AssetName: "",
      Question: "",
      RepairCompany: "",
      RepairDate: "",
      RepairPerson: "",
      RepairPersonNickName: "",
      ExpectedReturnDate: "",
      ExternalRepairId: "",
      ContactPerson: "",
      ContactPhone: "",
      Memo: "",
      ReturnMemo: "",
      ReturnPerson: "",
      ReturnPersonNickName: "",
      ReturnDate: "",
      Status: "",
      Area_Id: "",
      AreaName: "",
      Layer_Id: "",
      LayerName: "",
      // 報修照片
      newFile: [],
      viewFile: [], //不需要傳
      existFile: [], //不需要傳
      deleteFile: [],
      // 兩種文件共用
      newDocument: [],
      viewDocument: [], //不需要傳
      deleteDocument: [],
      // 維修文件
      existRepairDocument: [], //不需要傳
      // 驗收文件
      existReturnDocument: [], //不需要傳
      alreadyAccepted: false,
    },
    // 資產資料
    Assets: {
      Name: "",
      Type: "",
      Status: "",
    },
    // 其他判斷
    wrongStatus: false,
    canSubmit: false,
    alertMsg: "",
  }),
  // computed
  getters: {},
  // method
  actions: {
    /**
     * 輸入產編時搜尋資產，並改變狀態等
     * @param {String} newValue 新的 value
     * @param {String} oldValue 改變之前的 value
     */
    async watchAssetsId(newValue, oldValue) {
      const apiStore = useAPIStore();
      const assetData = await apiStore.getAssetData(newValue);
      if (assetData) {
        this.Assets.Name = assetData.AssetName;
        this.Assets.Type = assetData.AssetType;
        this.Assets.Status = assetData.Status;
        if (this.Assets.Type === "耗材") {
          this.wrongStatus = true;
          this.canSubmit = true;
          this.alertMsg = "僅提供資產類型為非耗材的物品進行維修";
        } else {
          // 檢查資產狀態(只有非耗材才會檢查)
          const Status = this.Assets.Status;
          const Type = this.Assets.Type;
          this.wrongStatus = true;
          this.canSubmit = false;
          switch (Status) {
            case "已被設備整合":
              this.alertMsg = `此${Type}已被設備整合，請先移出設備箱`;
              break;
            case "維修":
              this.alertMsg = `此${Type}已送修`;
              break;
            case "報廢":
            case "退貨":
              this.alertMsg = `此${Type}已${Status}`;
              break;
            default: // 可報修
              this.wrongStatus = false;
              this.canSubmit = true;
              this.alertMsg = "";
              break;
          }
        }
      } else {
        this.wrongStatus = true;
        this.canSubmit = false;
        this.Assets.Name = "";
        this.alertMsg = "請輸入正確的資產編號";
      }
    },
    /**
     * 報修單的新增/編輯
     * @param {String} type 'new' || 'edit'
     * @returns
     */
    async submit(type) {
      const utilsStore = useUtilsStore();
      // 由 watch 控制必填、 maxLength 限制長度。故無檢查
      let url;
      switch (type) {
        case "edit":
          url = "/RepairMng/RepairEdit";
          break;
        case "new":
          url = "/RepairMng/CreateOrder";
          break;
      }
      let requestData = {
        AssetsId: this.Form.AssetsId,
        Question: this.Form.Question,
        RepairCompany: this.Form.RepairCompany,
        newFile: this.Form.newFile,
      };
      // 編輯多單號和欲刪除檔案
      if (type === "edit") {
        requestData = {
          ...requestData,
          deleteFile: this.Form.deleteFile,
          RepairId: this.Form.RepairId,
        };
      }
      const form = new FormData();
      utilsStore.setFormData(requestData, form);
      try {
        const response = await axios.post(
          "" + url,
          form
        );
        const data = response.data;
        if (data.state === "success") {
          alert(data.messages + "\n單號:" + data.resultList.R_ID);
          router.push({ name: "Repair_Datagrid" });
        } else {
          alert(data.messages);
        }
      } catch (e) {
        console.error(e);
      }
    },
    // 取得報修單資料
    /**
     * 
     * @param {String} RepairId ID
     * @param {String[]} Conditions 可進入該頁面的資料單狀態
     * @param {String[]} editableDate 將可變更的日期轉為 DateObject
     */
    async getDetails(RepairId, Conditions, editableDate = []) {
      try {
        const response = await axios.get(
          `/GetDBdata/GetRepairInfo?r_id=${RepairId}`
        );
        const data = response.data;
        if (data.state === "success") {
          if (Conditions) {
            useUtilsStore().canEnterPage(data.resultList.Status, Conditions);
          }
          console.log("資料維修單資料", data.resultList);
          // 塞入表單資訊
          Object.keys(this.Form).forEach((key) => {
            if (data.resultList[key]) {
              this.Form[key] = data.resultList[key];
            }
          });
          if(editableDate.length > 0 ) {
            editableDate.forEach((key)=>{
              if(this.Form[key]) this.Form[key] = dayjs(this.Form[key]).format('YYYY-MM-DD');
            })
          }
          // 物品名稱
          this.Assets.Name = data.resultList.AssetName;
          this.canSubmit = true;
        }
      } catch (e) {
        console.error(e);
      }
    },
    /**
     * 刪除報修單
     * @param {*} RepairId 
     */
    async deleteData(RepairId) {
      const form = new FormData();
      form.append("RepairId", RepairId);
      try {
        const response = await axios.post(`/RepairMng/DeleteReceipt`, form);
        const data = response.data;
        if (data.state === "success") {
          let msg = data.messages + "\n單號:" + data.resultList.R_ID;
          alert(msg);
          router.push({
            name: "Case_Purchase_Datagrid",
          });
        } else if (data.state === "error") {
          alert(data.messages);
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
});
